import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayOfYear from "dayjs/plugin/dayOfYear";
import duration from "dayjs/plugin/duration";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isToday from "dayjs/plugin/isToday";
import isTomorrow from "dayjs/plugin/isTomorrow";
import isYesterday from "dayjs/plugin/isYesterday";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";

export const DEFAULT_LANGUAGE = "fr";

export const LocaleConfig: Record<string, { dayjs: string }> = {
  fr: { dayjs: "fr" },
  en: { dayjs: "en" },
};

/**
 *
 * Configure dayjs with all necessary plugins
 */
export const setupDayjs = () => {
  // Core plugins
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(customParseFormat);
  dayjs.extend(duration);

  // Comparison plugins
  dayjs.extend(isBetween);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(isSameOrAfter);

  // Helper plugins
  dayjs.extend(isToday);
  dayjs.extend(isTomorrow);
  dayjs.extend(isYesterday);
  dayjs.extend(relativeTime);
  dayjs.extend(weekday);
  dayjs.extend(weekOfYear);
  dayjs.extend(dayOfYear);

  // Set default locale
  dayjs.locale(LocaleConfig[DEFAULT_LANGUAGE].dayjs);
};

// Initialize on import
setupDayjs();

export default dayjs;
